import React from 'react';
import { ConsultantCard } from '../components/consultants/ConsultantCard';
import { ButtonLink } from '../components/ui/ButtonLink';
import { CtaBand } from '../components/ui/CtaBand';
import { PageHero } from '../components/ui/PageHero';
import { SectionHeading } from '../components/ui/SectionHeading';
import { consultants, searchApproach } from '../data/consultants';
import { usePageMeta } from '../hooks/usePageMeta';
export function Consultants() {
  usePageMeta('Our Consultants', 'Meet the Executive Search Consultants at Aurevane Search Partners. Contact Moshood A., Samuel A., Michael I., or Anne Precious directly by email.');
  return <>
      <PageHero compact label="Our Consultants" title="Meet Our Executive Search Consultants" intro="Our consultants focus on understanding leadership requirements, engaging experienced professionals, and facilitating thoughtful connections between candidates and organizations." data-id="element-682" data-mp="alu1olm2pe9j" />

      <section className="bg-porcelain py-20 lg:py-24" data-id="element-683" data-mp="es5oa84sy0jd">
        <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-684" data-mp="eqkvoo21sro5">
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-685" data-mp="jkfku70f9yum">
            {consultants.map(c => <ConsultantCard key={c.slug} consultant={c} headingLevel="h2" data-id="element-686" data-mp="5tag4qi76gdf" />)}
          </div>
        </div>
      </section>

      <section className="bg-limestone py-20 lg:py-28" data-id="element-687" data-mp="9r87nzzfxejz">
        <div className="mx-auto grid max-w-7xl gap-12 px-6 lg:grid-cols-12 lg:px-10" data-id="element-688" data-mp="xkgmvpsfbcbo">
          <div className="lg:col-span-5" data-id="element-689" data-mp="12ii2u1ujyvix">
            <SectionHeading label="How we work" title="A shared approach to every search" data-id="element-690" data-mp="12g5p60vtv7bo" />
          </div>
          <ul className="grid gap-x-10 gap-y-8 sm:grid-cols-2 lg:col-span-7" data-id="element-691" data-mp="oktjwzk1pygi">
            {searchApproach.map(a => <li key={a} className="border-t border-plum/15 pt-5 leading-relaxed text-plum/75" data-id="element-692" data-mp="398zfdd3sqt37">
                {a}
              </li>)}
          </ul>
        </div>
      </section>

      <CtaBand title="Speak with a consultant" text="Whether you are planning a leadership appointment or exploring your next executive role, our consultants are available to talk in confidence." data-id="element-693" data-mp="1jrkneuzah7bp">
        <ButtonLink to="/employers#inquiry" size="lg" data-id="element-694" data-mp="1a0zikpt0v6kc">
          Discuss Your Hiring Needs
        </ButtonLink>
        <ButtonLink to="/candidates#introduce" variant="outline-light" size="lg" data-id="element-695" data-mp="15z4jzt2h77a9">
          Introduce Yourself
        </ButtonLink>
      </CtaBand>
    </>;
}